import { getCachedProducts } from './offlineDB';
import { recalledOnShelf } from './recalledOnShelf';
import { getShelfSnapshot, getQueuedPulls, pullKey } from './offlineRecallPulls';

const SEEN = 'dutilyne_recall_seen';

// Offline view: stock from the cache, pull status from the last server snapshot plus queued ticks.
export const offlineShelf = async () => {
  const data = recalledOnShelf(await getCachedProducts().catch(() => []));
  const snap = await getShelfSnapshot();
  const known = {};
  (snap?.items || []).forEach((i) => i.batches.forEach((b) => { if (b.pulled) known[pullKey(i.product_id, b.batch_number)] = b.pulled; }));
  (await getQueuedPulls()).forEach((q) => { known[pullKey(q.product_id, q.batch_number)] = { ...q, pending: true }; });
  data.items.forEach((i) => i.batches.forEach((b) => { b.pulled = known[pullKey(i.product_id, b.batch_number)] || null; }));
  return data;
};

// True when the list has a recalled batch this till hasn't alerted for yet.
export const hasNewRecall = (items) => {
  let seen;
  try { seen = new Set(JSON.parse(localStorage.getItem(SEEN) || '[]')); } catch { seen = new Set(); }
  const keys = items.flatMap((i) => i.batches.map((b) => pullKey(i.product_id, b.batch_number)));
  const fresh = keys.some((k) => !seen.has(k));
  localStorage.setItem(SEEN, JSON.stringify(keys));
  return fresh;
};
